(ns dashboard.events.auth
  (:require
   [re-frame.core :as re-frame]
   [dashboard.interceptors :refer [standard-interceptors]]
   [dashboard.config :refer [api-url]]
   [ajax.core :as ajax]))

(re-frame/reg-event-fx
 ::do-login
 standard-interceptors
 (fn [{:keys [db]} _]
   {:db db
    :dispatch [::login-success]}))

(re-frame/reg-event-fx
 ::login-success
 standard-interceptors
 (fn [{:keys [db]} _]
   {:db (assoc db :signed-in? true)
    :navigate! [:route.home/home]}))

(re-frame/reg-event-fx
 ::do-logout
 standard-interceptors
 (fn [{:keys [db]} _]
   {:db db
    :dispatch [::logout-success]}))

(re-frame/reg-event-fx
 ::logout-success
 standard-interceptors
 (fn [{:keys [db]} _]
   {:db (assoc db
               :signed-in? false)
    :dispatch [:reset-db]
    :navigate! [:route.login/login]}))
